export default __webpack_public_path__ + "static/assets/fbb74035f54772ba1c7264cfa3ad3aa9.svg";